import { render } from "./TableNewList.vue?vue&type=template&id=2c731a70&scoped=true"
import script from "./TableNewList.vue?vue&type=script&lang=js"
export * from "./TableNewList.vue?vue&type=script&lang=js"

import "./TableNewList.vue?vue&type=style&index=0&id=2c731a70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c731a70"]])

export default __exports__